import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  IApiUserCalendarFilter,
} from "src/app/shared/modules/graphql/types/types";
import { DistanceSelectionPayload } from "./calendar-filters/calendar-user-distance-filter/calendar-user-distance-filter.component";

@Component({
  selector: "app-calendar",
  templateUrl: "./calendar.component.html",
  styleUrls: ["./calendar.component.scss"],
})
export class CalendarComponent implements OnInit {
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }

  @Input() public filters: IApiUserCalendarFilter[] = [];
  @Input() public userIds: string[] = [];
  @Input() public showFilters: boolean = true;
  @Input() public showTitle: boolean = true;
  @Input() public distanceSelection: DistanceSelectionPayload = {
    userIds: [],
    metrics: [],
  };
  @Input() public showTabs: boolean = true;
  public calendarLoading = false;
  public selectedTab = 0;

  public ngOnInit(): void {
    if (!this.showTabs) return;

    this.activatedRoute.queryParams.subscribe(params => {
      if (params.tab === 'conflict-check') {
        this.selectedTab = 1;
      } else {
        this.selectedTab = 0;
        if (!params.tab) {
          this.router.navigate([], {
            relativeTo: this.activatedRoute,
            queryParams: { tab: 'calendar' },
            queryParamsHandling: 'merge',
            replaceUrl: true
          });
        }
      }
    });
  }

  public onTabSelect(e: any): void {
    this.selectedTab = e.index;
    const tabName = this.selectedTab === 0 ? 'calendar' : 'conflict-check';
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { tab: tabName },
      queryParamsHandling: 'merge',
    });
  }

  public onApplyFilter(filters: IApiUserCalendarFilter[]): void {
    this.filters = filters;
  }

  public onClearFilter(): void {
    this.filters = [];
    this.userIds = [];
    this.distanceSelection = {
      userIds: [],
      metrics: [],
    };
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        address: null,
        lat: null,
        lng: null
      },
      queryParamsHandling: 'merge'
    });
  }

  public onDistanceSelectionChange(payload: DistanceSelectionPayload): void {
    this.distanceSelection = payload || { userIds: [], metrics: [] };
  }
}
